import React, { useRef, useState } from 'react';
import { Editor } from '@tinymce/tinymce-react';

const AddWorkshopModal = ({ newWorkshop, setNewWorkshop, onSubmit, categories }) => {
  const editorRef = useRef(null);
  const [imagePreview, setImagePreview] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewWorkshop({ ...newWorkshop, [name]: value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setNewWorkshop({ ...newWorkshop, image: file });
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleAddDate = () => {
    const newDate = { date: '', max_participants: 12 };
    setNewWorkshop({ ...newWorkshop, dates: [...(newWorkshop.dates || []), newDate] });
  };

  const handleDateChange = (index, key, value) => {
    const updatedDates = [...newWorkshop.dates];
    updatedDates[index][key] = value;
    setNewWorkshop({ ...newWorkshop, dates: updatedDates });
  };

  const handleDateRemove = (index) => {
    const updated = newWorkshop.dates.filter((_, i) => i !== index);
    setNewWorkshop({ ...newWorkshop, dates: updated });
  };

  return (
    <div className="modal" id="addWorkshopModal" tabIndex="-1">
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <form onSubmit={(e) => onSubmit(e, newWorkshop)}>
            <div className="modal-header">
              <h5 className="modal-title">Ajouter un atelier</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">Image</label>
                {imagePreview && <img src={imagePreview} alt="preview" className="img-fluid mb-2" style={{ maxHeight: '150px' }} />}
                <input type="file" className="form-control" accept="image/*" onChange={handleImageChange} />
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Titre</label>
                    <input type="text" name="title" className="form-control" value={newWorkshop.title} onChange={handleInputChange} required />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Référence</label>
                    <input type="text" name="reference" className="form-control" value={newWorkshop.reference} onChange={handleInputChange} required />
                  </div>
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label">Catégorie</label>
                <select className="form-select" name="category" value={newWorkshop.category} onChange={handleInputChange} required>
                  <option value="">Sélectionner</option>
                  {categories.map((cat) => (
                    <option key={cat.id} value={cat.id}>{cat.name}</option>
                  ))}
                </select>
              </div>

              <div className="mb-3">
                <label className="form-label">Description courte</label>
                <textarea name="short_description" className="form-control" rows="2" value={newWorkshop.short_description} onChange={handleInputChange}></textarea>
              </div>

              <div className="mb-3">
                <label className="form-label">Description</label>
                <Editor
                  onInit={(evt, editor) => editorRef.current = editor}
                  init={{ height: 300, menubar: false, plugins: ['lists', 'autoresize'], toolbar: 'bold italic underline | bullist numlist | removeformat' }}
                  onEditorChange={(content) => setNewWorkshop({ ...newWorkshop, description: content })}
                />
              </div>

              <div className="row">
                <div className="col-md-6">
                  <label className="form-label">Durée (minutes)</label>
                  <input type="number" name="duration" className="form-control" value={newWorkshop.duration} onChange={handleInputChange} />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Prix (€)</label>
                  <input type="number" step="0.00" name="price" className="form-control" value={newWorkshop.price} onChange={handleInputChange} />
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-md-6">
                  <label className="form-label">Lieu</label>
                  <input type="text" name="location" className="form-control" value={newWorkshop.location} onChange={handleInputChange} />
                </div>
                <div className="col-md-6">
                  {/* <label className="form-label">Participants max</label> */}
                  {/* <input type="number" name="max_participants" className="form-control" value={newWorkshop.max_participants} onChange={handleInputChange} /> */}
                </div>
              </div>

              <hr className="my-4" />
              <h6>Dates de l'atelier</h6>
              {newWorkshop.dates.map((d, i) => (
                <div key={i} className="row align-items-end mb-2">
                  <div className="col-md-6">
                    <label className="form-label">Date</label>
                    <input 
                      type="datetime-local" 
                      className="form-control" 
                      value={d.date} 
                      onChange={(e) => {
                        handleDateChange(i, 'date', e.target.value)
                        handleDateChange(i, 'max_participants', 500)
                      }} 
                      required 
                    />
                  </div>
                  <div className="col-md-4">
                    {/* <label className="form-label">Participants max</label> */}
                    {/* <input type="hidden" className="form-control" value={50} onChange={(e) => handleDateChange(i, 'max_participants', e.target.value)} /> */}
                  </div>
                  <div className="col-md-2">
                    <button type="button" className="btn btn-danger" onClick={() => handleDateRemove(i)}>Supprimer</button>
                  </div>
                </div>
              ))}
              <button type="button" className="btn btn-secondary mt-2" onClick={handleAddDate}>Ajouter une date</button>
            </div>

            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Annuler</button>
              <button type="submit" className="btn btn-primary">Ajouter</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddWorkshopModal;